import { Card, Group, Image, List, ListItem, Stack, Text, Title } from '@mantine/core'
import { TwContainer } from '@/lib/components/TwContainer'

export const HivSectionThree = () => {
	return (
		<section className={'bg-secondary'}>
			<TwContainer className={'justify-center py-16 pt-32 gap-12'} column>
				<Group gap={0} justify={'space-around'}>
					<Image
						loading={'lazy'}
						className={'order-last md:order-first md:max-w-sm max-w-xs rounded-[32px]'}
						src={'/images/img_25.webp'}
						w={380}
						h={380}
						alt={'Human Immuno deficiency Virus (HIV)'}
					/>
					<Stack className={'max-w-lg p-8'} gap={'xs'}>
						<Title variant={'cyan'} fz={18}>
							Why Treat HIV?
						</Title>
						<Title variant={'title2'}>
							Maintaining a Healthy
							<br />
							Immune System
						</Title>
						<Text variant={'gray'} ta={'left'}>
							Over time, chronic HIV can leave the body defenseless against a range of infections that the body can typically ward off, such as
							tuberculosis or pneumonia. Through advancements in treatments, including BIKTARVY®, HIV can be reduced to undetectable levels.
						</Text>
					</Stack>
				</Group>
				<Group gap={0} justify={'space-around'}>
					<Stack className={'max-w-lg p-8'} gap={'xs'}>
						<Title variant={'cyan'} fz={18}>
							Which Treatment Is Best?
						</Title>
						<Title variant={'title2'}>Choosing BIKTARVY®</Title>
						<Text variant={'gray'} ta={'left'}>
							At Wellview Care, BIKTARVY® is our preferred treatment method based on its 5 years of thorough testing and exceptional track record of
							suppressing HIV to undetectable levels for many patients within 8 to 24 weeks through a small, once-daily pill.
						</Text>
					</Stack>
					<Image
						loading={'lazy'}
						className={'md:max-w-sm max-w-xs rounded-[32px]'}
						src={'/images/img_26.webp'}
						w={380}
						h={380}
						alt={'Sexually transmitted infections (STIs)'}
					/>
				</Group>
				<Group gap={0} justify={'space-around'}>
					<Image
						loading={'lazy'}
						className={'order-last md:order-first md:max-w-xl max-w-xs rounded-[32px]'}
						src={'/images/img_18.webp'}
						w={480}
						h={480}
						alt={'WHY WELLVIEW CARE?'}
					/>
					<Stack className={'max-w-xl p-8'} gap={'xs'}>
						<Title variant={'cyan'} fz={18}>
							WHY WELLVIEW CARE?
						</Title>
						<Title variant={'title2'}>
							Empowering HIV-Positive
							<br />
							Patients to Live Fully
						</Title>
						<Text variant={'gray'} ta={'left'}>
							At Wellview Care we prioritize your health and peace of mind. Here&apos;s why you should choose us for all your HIV-related needs:
						</Text>
						<List type={'ordered'} spacing={'lg'}>
							<ListItem>
								<strong>Expertise:</strong> Our experienced medical professionals specialize in HIV testing, diagnosis, and treatment. We stay updated
								with the latest advancements in HIV care to provide you with the best services.
							</ListItem>
							<ListItem>
								<strong>Confidentiality:</strong> We respect your privacy and ensure all interactions and test results are kept strictly confidential.
								Your personal information is safe with us.
							</ListItem>
							<ListItem>
								<strong>Cutting-Edge Testing:</strong> We use state-of-the-art testing methods to provide accurate and fast results. Our testing is
								performed with the utmost care and precision.
							</ListItem>
							<ListItem>
								<strong> Counseling and Support:</strong> We offer comprehensive counseling services to address your concerns, answer your questions,
								and provide guidance throughout the testing process. We&apos;re here to support you every step of the way.
							</ListItem>
						</List>
					</Stack>
				</Group>
			</TwContainer>
			<TwContainer className={'justify-center py-16 pt-32'} column>
				<Title ta={'center'} variant={'cyan'} fz={18}>
					OUR PROCESS
				</Title>
				<Title variant={'title'}>Starting Your HIV Treatment</Title>
				<Group mt={'xl'} justify={'center'} align={'stretch'} gap={48}>
					<Card
						style={{
							boxShadow: '0px 0px 4px 0px rgba(0, 0, 0, 0.15)',
						}}
						className={' flex-col flex gap-2 justify-center max-w-xs  p-6 items-center py-12'}
						radius={20}
					>
						<Image loading={'lazy'} src={'/images/img_19.webp'} w={50} h={56} alt={'STD'} />
						<Title variant={'subtitle'} fz={24}>
							Insurance Confirmation
						</Title>
						<Text variant={'gray'}>
							While we offer HIV treatments regardless of your insurance status, confirming your insurance coverage is our first step.
						</Text>
					</Card>
					<Card
						style={{
							boxShadow: '0px 0px 4px 0px rgba(0, 0, 0, 0.15)',
						}}
						className={' flex-col flex gap-2 justify-center max-w-xs  p-6 items-center py-12'}
						radius={20}
					>
						<Image loading={'lazy'} src={'/images/img_20.webp'} w={42} h={67.2} alt={'STD'} />
						<Title variant={'subtitle'} fz={24}>
							Financial Aid
						</Title>
						<Text variant={'gray'}>
							Our goal is for anyone living with HIV to have access to treatments, which is why we support those who qualify with financial assistance
							applications.
						</Text>
					</Card>
					<Card
						style={{
							boxShadow: '0px 0px 4px 0px rgba(0, 0, 0, 0.15)',
						}}
						className={' flex-col flex gap-2 justify-center max-w-xs  p-6 items-center py-12'}
						radius={20}
					>
						<Image loading={'lazy'} src={'/images/img_3.webp'} w={50} h={55} alt={'STD'} />
						<Title variant={'subtitle'} fz={24}>
							HIV Treatments
						</Title>
						<Text variant={'gray'}>
							Our experienced Medical Assistants (MAs), Advanced Registered Nurse Practitioners (ARNPs) and Medical Directors support you with
							everything from treatments to ongoing testing.
						</Text>
					</Card>
				</Group>
			</TwContainer>
		</section>
	)
}
